import AppConstants from "../../../config/app.constants";
import BranchFundingSourceHolidayBaseController from '../common/branch_funding_source_holiday.base.controller'

class BranchFundingSourceHolidayCreateController extends BranchFundingSourceHolidayBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BranchFundingSourceHolidayService, BranchFundingSourceService, DateUtil) {

        super(Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BranchFundingSourceHolidayService = BranchFundingSourceHolidayService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DateUtil = DateUtil;

        this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            holidayDate: new Date(),
            repeat: false,
            selectedFundingSource: null,
            branchFundingSourceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
        };

        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no'),
            },
            onColor: 'success',
            offColor: 'danger'
        }

        this.model = angular.copy(this.defaultModel);
    }

    $onInit() {
        this.loadData();
    }

    generateSearchObj(searchKey) {
        searchKey = searchKey || '';
        const obj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "sourceName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    getAllFundingSource(searchKey, offset) {
        this.model.branchFundingSourceObj.loading = true;
        const searchObj = this.generateSearchObj(searchKey);

        this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.branchFundingSourceObj.totalRecords = data.total;
                    this.model.branchFundingSourceObj.results = this.fundingSourceMap(data.results);
                }
                else {
                    const fundingSource = this.fundingSourceMap(data.results);
                    this.model.branchFundingSourceObj.results = this.model.branchFundingSourceObj.results.concat(fundingSource);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.branchFundingSourceObj.loading = false;
            })
    }

    fundingSourceMap(fundingSource) {
        return fundingSource.map((data) => {
            return {
                Key: data.id + ' | ' + data.sourceName,
                Value: data.id
            }
        });
    }

    submit() {
        this.model.isCreate = true;
        delete this.model.errorMessage;

        this.Service.create({
            name: this.model.name,
            holidayDate: this.DateUtil.getUTCDate(this.model.holidayDate),
            repeat: this.model.repeat,
            branchFundingSourceId: this.model.selectedFundingSource.Value,
            branchId: this.model.branchId
        })
            .then(() => {
                this.askCreate().then(() => this.loadData())
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

    loadData() {
        this.getAllFundingSource('', 0);
    }

    reset() {
        // this.model = angular.copy(this.defaultModel);
        this.model.name = null;
        this.model.holidayDate = new Date();
        this.model.repeat = false;
        this.model.selectedFundingSource = null;
        this.clearErrors();
    }

}
export default BranchFundingSourceHolidayCreateController;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/create/branch_funding_source_holiday.create.controller.js